import { Play } from "lucide-react";

import { useTranslation } from 'react-i18next';
const VIDEO_PLACEHOLDERS = [
  {
    name: "James Mitchell",
    role: "Operations Manager, SaaS Co.",
    duration: "2:30",
  },
  {
    name: "Rebecca Santos",
    role: "Freelance Designer",
    duration: "2:30",
  },
  {
    name: "David Park",
    role: "Founder, E-commerce",
    duration: "2:30",
  },
];

function VideoCard({ video }) {
  const { t } = useTranslation();
  return (
    <div className="bg-zinc-950 border border-zinc-800 rounded-lg overflow-hidden group hover:border-amber-500/30 transition-all duration-300 hover:scale-[1.02]">
      {/* Thumbnail placeholder */}
      <div className="relative aspect-video bg-zinc-900 flex items-center justify-center">
        {/* Play button */}
        <div className="w-16 h-16 bg-amber-500/20 border-2 border-amber-500 rounded-full flex items-center justify-center group-hover:bg-amber-500/30 transition-colors">
          <Play className="w-6 h-6 text-amber-500 ml-1" fill="currentColor" aria-hidden="true" />
        </div>
        {/* COMING SOON badge */}
        <div className="absolute top-2 right-2 bg-amber-500 text-black text-[10px] font-bold px-2 py-1 rounded font-display uppercase tracking-wider">
          {t('video_testimonial_section.coming_soon')}
        </div>
        {/* Duration badge */}
        <div className="absolute bottom-2 right-2 bg-black/70 backdrop-blur-sm text-zinc-300 text-[10px] font-mono px-2 py-1 rounded">
          {video.duration}
        </div>
      </div>
      {/* Card info */}
      <div className="p-4">
        <div className="font-display text-sm uppercase text-white">{video.name}</div>
        <div className="font-mono text-[10px] uppercase tracking-[0.15em] text-zinc-500 mt-1">{video.role}</div>
      </div>
    </div>
  );
}

export default function VideoTestimonialSection() {
  const { t } = useTranslation();
  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-12 py-24" aria-labelledby="video-testimonials-heading">
      <div className="text-center mb-16">
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber-500 mb-4" aria-hidden="true">
          // VIDEO TESTIMONIALS
        </div>
        <h2 id="video-testimonials-heading" className="font-display text-4xl md:text-5xl uppercase leading-tight">
          See Max OS<br /><span className="text-amber-500">in Action</span>
        </h2>
        <p className="mt-4 text-zinc-400 text-lg">{t('video_testimonial_section.real_businesses_real_results_real_videos')}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {VIDEO_PLACEHOLDERS.map((video) => (
          <VideoCard key={video.name} video={video} />
        ))}
      </div>
    </section>
  );
}
